import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ITeacher } from '@/Module/Teacher/Model/DataModel';
import { getTeacherByIdAction } from '@/Module/Teacher/Store/Action';
import { getTeacherBySeoUrlSlugAction } from '@/Module/Teacher/Store/Action/getTeacherBySeoUrlSlugAction';
import { teacherAdapter } from '@/Module/Teacher/Store/Adapter';

const TeacherSlice = createSlice({
  name: 'teacher',
  initialState: teacherAdapter.getInitialState({
    isLoading: false,
    page: 0,
    rows: 12,
    total: 0,
    selectedId: null as ITeacher['id'] | null,
  }),
  reducers: {
    setPage: (state, { payload }: PayloadAction<number>) => {
      state.page = payload;
    },
    nextPage: state => {
      state.page += 1;
    },
    setSelectedTeacherSectionId: (state, { payload }: PayloadAction<ITeacher['id'] | null>) => {
      state.selectedId = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getTeacherByIdAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getTeacherByIdAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getTeacherByIdAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // removing sensitive data from teacher
        // eslint-disable-next-line unused-imports/no-unused-vars
        const { phoneNumber, nationalCode, ...rest } = payload.person;
        teacherAdapter.setOne(state, { ...payload, person: rest });
      });

    builder
      .addCase(getTeacherBySeoUrlSlugAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getTeacherBySeoUrlSlugAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getTeacherBySeoUrlSlugAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // removing sensitive data from teacher
        // eslint-disable-next-line unused-imports/no-unused-vars
        const { phoneNumber, nationalCode, ...rest } = payload.person;
        teacherAdapter.setOne(state, { ...payload, person: rest });
      });
  },
});

export const { setSelectedTeacherSectionId: teacherSetSelectedIdAction } = TeacherSlice.actions;

export default TeacherSlice;
